import { render, staticRenderFns } from "./FarmGeofenceZoneEdit.vue?vue&type=template&id=221124a9&scoped=true"
import script from "./FarmGeofenceZoneEdit.vue?vue&type=script&lang=js"
export * from "./FarmGeofenceZoneEdit.vue?vue&type=script&lang=js"
import style0 from "./FarmGeofenceZoneEdit.vue?vue&type=style&index=0&id=221124a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221124a9",
  null
  
)

export default component.exports